import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _Grid;
import React, { useState, createElement as _createElement } from 'react';
import Grid from '@crehana/compass.icons.outline/Grid';
import { PopperContent, PopperTrigger } from '@crehana/compass.ui/v2';
import { HanaChip } from "../../hana-chip/hana-chip";
import { filters } from "../../hana-home-container/constants";
import { HanaInputFilter } from "../../hana-input-filter";
import { useVisibleCategories } from "../../hooks";
import { TargetSegmentEnum } from "../../shared/types";
import { useBannerCategoriesTranslation } from "../i18n";
import { IconsFolders } from "../icons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CategoryFilter = /*#__PURE__*/React.memo(function (_ref) {
  var adaptedCategories = _ref.adaptedCategories,
    onSelectItem = _ref.onSelectItem,
    selectedItem = _ref.selectedItem,
    targetSegment = _ref.targetSegment;
  var _useBannerCategoriesT = useBannerCategoriesTranslation(),
    t = _useBannerCategoriesT.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCategory = _useState2[0],
    setSelectedCategory = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCategoriesSection = _useState4[0],
    setShowCategoriesSection = _useState4[1];
  var _useVisibleCategories = useVisibleCategories((adaptedCategories || []).map(function (cat) {
      return {
        id: cat.id,
        name: cat.name || '',
        icon_id: cat.icon_id || '',
        description: cat.description || '',
        copilot_prompts: cat.copilot_prompts.map(function (prompt) {
          return {
            id: prompt.id,
            name: prompt.name || '',
            description: prompt.description || '',
            template: prompt.template ? {
              id: prompt.template.id,
              name: prompt.template.name || '',
              prompt: prompt.template.prompt || '',
              suggested_prompt: []
            } : null
          };
        })
      };
    })),
    visibleCategories = _useVisibleCategories.visibleCategories,
    isExceedingLimitCategories = _useVisibleCategories.isExceedingLimitCategories;
  var filteredItems = React.useMemo(function () {
    var category = adaptedCategories === null || adaptedCategories === void 0 ? void 0 : adaptedCategories.find(function (category) {
      return category.id === selectedCategory;
    });
    var items = category === null || category === void 0 ? void 0 : category.copilot_prompts.map(function (prompt) {
      var _prompt$template;
      return {
        label: ((_prompt$template = prompt.template) === null || _prompt$template === void 0 ? void 0 : _prompt$template.prompt) || '',
        category: category.name || '',
        id: category.id || ''
      };
    });
    return items;
  }, [selectedCategory, adaptedCategories]);
  var handleCategoryClick = function handleCategoryClick(categoryId) {
    setShowCategoriesSection(false);
    setSelectedCategory(categoryId);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-gap-2.4",
    children: [/*#__PURE__*/_jsx(PopperContent, {
      align: "center",
      side: "bottom",
      className: "tw-w-full tw-mt-1.2 tw-p-0",
      sideOffset: -50
      // I need to control the focus because inside of the popper there is a tooltip component that opens immediately when the popper is open
      // The tooltip should open only when the user hovers over the element
      ,
      onOpenAutoFocus: function onOpenAutoFocus(e) {
        return e.preventDefault();
      },
      onCloseAutoFocus: function onCloseAutoFocus(e) {
        return e.preventDefault();
      },
      children: showCategoriesSection ? /*#__PURE__*/_jsx(HanaInputFilter, {
        filters: filters,
        items: (adaptedCategories === null || adaptedCategories === void 0 ? void 0 : adaptedCategories.flatMap(function (category) {
          return category.copilot_prompts.map(function (prompt) {
            return {
              label: prompt.name || '',
              category: category.name || ''
            };
          });
        })) || [],
        selectedItem: selectedItem,
        onSelectItem: onSelectItem,
        targetSegment: TargetSegmentEnum.Admin
      }) : /*#__PURE__*/_jsx(HanaInputFilter, {
        filters: filters,
        items: filteredItems || [],
        selectedItem: selectedItem,
        onSelectItem: onSelectItem,
        targetSegment: TargetSegmentEnum.EndUser
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-gap-0.8",
      children: [visibleCategories.map(function (category) {
        var iconFolder = IconsFolders.find(function (icon) {
          return icon.value === category.icon_id;
        });
        return /*#__PURE__*/_jsx(PopperTrigger, {
          type: "button",
          children: /*#__PURE__*/_createElement(HanaChip, _objectSpread(_objectSpread({}, category), {}, {
            Icon: (iconFolder === null || iconFolder === void 0 ? void 0 : iconFolder.label) && /*#__PURE__*/React.cloneElement(iconFolder.label, {
              size: 20,
              className: 'tw-text-neutral-light-700 group-hover:tw-text-primary-light-500'
            }),
            key: category.id,
            onClick: function onClick() {
              return handleCategoryClick(category.id);
            }
          }))
        }, category.id);
      }), targetSegment === 'admin' && isExceedingLimitCategories && /*#__PURE__*/_jsx(PopperTrigger, {
        type: "button",
        children: /*#__PURE__*/_jsx(HanaChip, {
          name: t('LABEL_CATEGORIES'),
          hasMoreCategories: true,
          onClick: function onClick() {
            return setShowCategoriesSection(true);
          },
          Icon: _Grid || (_Grid = /*#__PURE__*/_jsx(Grid, {
            size: 20,
            className: "tw-text-neutral-light-700 group-hover:tw-text-primary-light-500"
          })),
          id: "categories-chip",
          copilot_prompts: [],
          description: ""
        })
      })]
    })]
  });
});
CategoryFilter.displayName = 'CategoryFilter';